/* UK Designer theme script. No dependencies besides the optional vendored Lenis. */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $ = function (sel, ctx) { return (ctx || doc).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); };
  var routes = (window.UKD && window.UKD.routes) || { cartAdd: '/cart/add', cartChange: '/cart/change', root: '/' };

  /* ------------------------------------------------------------ smooth scroll */
  var lenis = null;
  if (!reduceMotion && finePointer && window.Lenis) {
    try {
      lenis = new window.Lenis({ lerp: 0.11, smoothWheel: true, wheelMultiplier: 1 });
      var raf = function (t) { lenis.raf(t); requestAnimationFrame(raf); };
      requestAnimationFrame(raf);
    } catch (e) { lenis = null; }
  }
  window.UKD = window.UKD || {};
  window.UKD.lenis = lenis;

  function scrollToEl(el, offset) {
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: offset || -100 });
    else el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  doc.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || a.getAttribute('href').length < 2) return;
    var target = doc.getElementById(a.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    scrollToEl(target);
    if (target.id === 'MainContent') target.focus({ preventScroll: true });
  });

  /* ------------------------------------------------------------ scroll-driven bits */
  var header = $('[data-header]');
  var progress = $('[data-progress]');
  var toTop = $('[data-to-top]');
  var ring = $('[data-to-top-ring]');
  var parallax = reduceMotion ? [] : $$('[data-px]');
  var lastY = window.scrollY;
  var ticking = false;

  function onScroll() {
    var y = window.scrollY;
    var max = Math.max(1, doc.documentElement.scrollHeight - window.innerHeight);
    var ratio = Math.min(1, y / max);

    if (header) {
      header.classList.toggle('is-scrolled', y > 24);
      var hide = y > 240 && y > lastY + 2 && !doc.body.classList.contains('is-locked');
      if (y < lastY - 2 || y < 240) header.classList.remove('is-hidden');
      else if (hide) header.classList.add('is-hidden');
    }
    if (progress) progress.style.transform = 'scaleX(' + ratio + ')';
    if (toTop) {
      toTop.classList.toggle('is-visible', y > window.innerHeight * 0.9);
      if (ring) ring.style.strokeDashoffset = String(126 - 126 * ratio);
    }
    for (var i = 0; i < parallax.length; i++) {
      var el = parallax[i];
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > window.innerHeight + 200) continue;
      var speed = parseFloat(el.getAttribute('data-px')) || 0;
      var center = r.top + r.height / 2 - window.innerHeight / 2;
      el.style.transform = 'translate3d(0,' + (center * speed).toFixed(1) + 'px,0)';
    }
    lastY = y;
    ticking = false;
  }
  function requestScroll() { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }
  window.addEventListener('scroll', requestScroll, { passive: true });
  window.addEventListener('resize', requestScroll, { passive: true });
  onScroll();

  if (toTop) toTop.addEventListener('click', function () {
    if (lenis) lenis.scrollTo(0); else window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  /* ------------------------------------------------------------ split headings */
  function splitWords(el) {
    if (el.dataset.splitDone) return;
    el.dataset.splitDone = '1';
    var text = el.textContent.trim().replace(/\s+/g, ' ');
    el.setAttribute('aria-label', text);
    el.textContent = '';
    text.split(' ').forEach(function (word, i, arr) {
      var w = doc.createElement('span');
      w.className = 'w';
      w.setAttribute('aria-hidden', 'true');
      var inner = doc.createElement('span');
      inner.textContent = word;
      inner.style.setProperty('--wi', i);
      w.appendChild(inner);
      el.appendChild(w);
      if (i < arr.length - 1) el.appendChild(doc.createTextNode(' '));
    });
  }
  if (!reduceMotion) $$('[data-split]').forEach(splitWords);

  /* ------------------------------------------------------------ reveal on view */
  var revealSel = '[data-r], [data-split], [data-reveal-clip], .timeline li';
  var io = null;
  if ('IntersectionObserver' in window && !reduceMotion) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          if (el.matches(revealSel)) el.classList.add('is-in');
          (el.__reveal || []).forEach(function (t) { t.classList.add('is-in'); });
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
  }
  function observeReveals(ctx) {
    $$(revealSel, ctx).forEach(function (el) {
      if (!io) { el.classList.add('is-in'); return; }
      // An element hidden by its own clip-path never reports as intersecting, so watch its parent.
      if (el.hasAttribute('data-reveal-clip') && el.parentElement) {
        var p = el.parentElement;
        (p.__reveal = p.__reveal || []).push(el);
        io.observe(p);
      } else {
        io.observe(el);
      }
    });
  }
  observeReveals(doc);

  /* ------------------------------------------------------------ counters */
  function countUp(el) {
    var end = parseInt(el.getAttribute('data-count'), 10);
    if (!end || reduceMotion) return;
    var start = performance.now();
    var dur = 1400;
    var step = function (t) {
      var p = Math.min(1, (t - start) / dur);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = String(Math.round(end * eased));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { countUp(en.target); cio.unobserve(en.target); } });
    }, { threshold: 0.6 });
    $$('[data-count]').forEach(function (el) { cio.observe(el); });
  }

  /* ------------------------------------------------------------ magnetic buttons */
  if (finePointer && !reduceMotion) {
    doc.addEventListener('pointermove', function (e) {
      var btn = e.target.closest('[data-magnetic]');
      if (!btn) return;
      var r = btn.getBoundingClientRect();
      var x = (e.clientX - r.left - r.width / 2) * 0.18;
      var y = (e.clientY - r.top - r.height / 2) * 0.28;
      btn.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
    });
    doc.addEventListener('pointerout', function (e) {
      var btn = e.target.closest('[data-magnetic]');
      if (btn && !btn.contains(e.relatedTarget)) btn.style.transform = '';
    });
  }

  /* ------------------------------------------------------------ nav blob */
  (function navBlob() {
    var nav = $('[data-nav]');
    var blob = $('[data-nav-blob]');
    if (!nav || !blob) return;
    var links = $$('.site-nav__link', nav);
    var active = links.filter(function (l) { return l.classList.contains('is-active'); })[0];
    function moveTo(link) {
      // Text colour always follows the pill, so the active link never turns light on a light background.
      links.forEach(function (l) { l.style.color = l === link ? 'var(--paper)' : 'var(--ink)'; });
      if (!link) { blob.style.opacity = '0'; return; }
      blob.style.opacity = '1';
      blob.style.width = link.offsetWidth + 'px';
      blob.style.transform = 'translateX(' + link.offsetLeft + 'px)';
    }
    function reset() { moveTo(active); }
    links.forEach(function (l) {
      l.addEventListener('pointerenter', function () { moveTo(l); });
      l.addEventListener('focus', function () { moveTo(l); });
    });
    nav.addEventListener('pointerleave', reset);
    nav.addEventListener('focusout', function (e) { if (!nav.contains(e.relatedTarget)) reset(); });
    window.addEventListener('resize', reset);
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(reset);
    reset();
    requestAnimationFrame(function () { blob.classList.add('is-ready'); });
  })();

  /* ------------------------------------------------------------ announcement */
  (function announce() {
    var items = $$('.announce__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      if (doc.hidden) return;
      var cur = items[i];
      i = (i + 1) % items.length;
      cur.classList.add('is-leaving');
      cur.classList.remove('is-active');
      items[i].classList.remove('is-leaving');
      items[i].classList.add('is-active');
      setTimeout(function () { cur.classList.remove('is-leaving'); }, 900);
    }, 4800);
  })();

  /* ------------------------------------------------------------ overlays */
  var openOverlay = null;
  var lastFocus = null;
  var focusables = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function lock(on) {
    doc.body.classList.toggle('is-locked', on);
    if (lenis) { if (on) lenis.stop(); else lenis.start(); }
  }
  function open(name, trigger) {
    var ov = $('[data-overlay="' + name + '"]');
    if (!ov) return false;
    if (openOverlay && openOverlay !== ov) close(true);
    lastFocus = trigger || doc.activeElement;
    ov.hidden = false;
    lock(true);
    // Force a reflow so the transition runs from the closed state without waiting for animation frames.
    void ov.offsetWidth;
    ov.classList.add('is-open');
    var first = ov.querySelector('[data-search-input]') || ov.querySelector(focusables);
    if (first) first.focus({ preventScroll: true });
    openOverlay = ov;
    $$('[aria-controls="' + ov.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    return true;
  }
  function close(silent) {
    var ov = openOverlay;
    if (!ov) return;
    ov.classList.remove('is-open');
    openOverlay = null;
    $$('[aria-controls="' + ov.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { if (!ov.classList.contains('is-open')) ov.hidden = true; }, reduceMotion ? 0 : 650);
    lock(false);
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.UKD.openOverlay = open;
  window.UKD.closeOverlay = close;

  doc.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      var name = opener.getAttribute('data-open');
      if (name === 'cart' && doc.body.classList.contains('template-cart')) return;
      if (open(name, opener)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close]') && openOverlay) { e.preventDefault(); close(); }
  });
  doc.addEventListener('keydown', function (e) {
    if (!openOverlay) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var items = $$(focusables, openOverlay).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ------------------------------------------------------------ predictive search */
  (function search() {
    var input = $('[data-search-input]');
    var out = $('[data-search-results]');
    if (!input || !out) return;
    var timer, ctrl;
    var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = 'AbortController' in window ? new AbortController() : null;
        fetch(routes.root.replace(/\/$/, '') + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!items.length) { out.innerHTML = '<p class="muted">No products match “' + esc(q) + '”.</p>'; return; }
            out.innerHTML = items.map(function (p) {
              var img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="56" height="70" loading="lazy">' : '';
              var name = esc(p.title.replace(/^UK Designer /, ''));
              return '<a class="search-result" href="' + esc(p.url) + '">' + img + '<span><b>' + name + '</b><span>£' + esc(Number(p.price).toFixed(2)) + '</span></span></a>';
            }).join('');
          })
          .catch(function () {});
      }, 220);
    });
  })();

  /* ------------------------------------------------------------ tabs filter */
  $$('[data-filter-scope]').forEach(function (scope) {
    var tabs = $('[data-tabs]', scope);
    var grid = $('[data-filter-grid]', scope);
    if (!tabs || !grid) return;
    var pill = $('[data-tabs-pill]', tabs);
    var btns = $$('[data-filter]', tabs);
    function place(btn) {
      if (!pill) return;
      pill.style.width = btn.offsetWidth + 'px';
      pill.style.transform = 'translateX(' + (btn.offsetLeft - 5) + 'px)';
      pill.style.left = '5px';
    }
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.getAttribute('data-filter');
        btns.forEach(function (b) { var on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
        place(btn);
        var shown = 0;
        $$('[data-card]', grid).forEach(function (card) {
          var match = f === 'all' || card.getAttribute('data-gender') === f;
          card.classList.toggle('is-filtered', !match);
          if (match) {
            card.style.setProperty('--d', (shown % 4) * 70 + 'ms');
            card.classList.remove('is-in');
            void card.offsetWidth;
            requestAnimationFrame(function () { card.classList.add('is-in'); });
            shown++;
          }
        });
      });
    });
    var activeBtn = $('.is-active', tabs);
    if (activeBtn) { place(activeBtn); if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(function () { place($('.is-active', tabs)); }); }
    window.addEventListener('resize', function () { var a = $('.is-active', tabs); if (a) place(a); });
  });

  /* ------------------------------------------------------------ carousel */
  $$('[data-carousel]').forEach(function (car) {
    var section = car.closest('section');
    var track = $('[data-car-track]', car);
    var bar = section && $('[data-car-bar]', section);
    var prev = section && $('[data-car-prev]', section);
    var next = section && $('[data-car-next]', section);
    var stepSize = function () { var item = track.firstElementChild; return item ? item.getBoundingClientRect().width + 20 : 300; };
    var update = function () {
      var max = car.scrollWidth - car.clientWidth;
      var visible = car.clientWidth / car.scrollWidth;
      var p = max > 0 ? car.scrollLeft / max : 1;
      if (bar) bar.style.transform = 'translateX(' + (p * (1 / visible - 1) * 100).toFixed(2) + '%) scaleX(1)';
      if (bar) bar.style.width = (visible * 100).toFixed(2) + '%';
      if (prev) prev.disabled = car.scrollLeft < 4;
      if (next) next.disabled = car.scrollLeft > max - 4;
    };
    car.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    if (prev) prev.addEventListener('click', function () { car.scrollBy({ left: -stepSize(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { car.scrollBy({ left: stepSize(), behavior: 'smooth' }); });
    update();

    if (finePointer) {
      var down = false, startX = 0, startLeft = 0, moved = false;
      car.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; startX = e.clientX; startLeft = car.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 5) { moved = true; car.classList.add('is-dragging'); }
        car.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        car.classList.remove('is-dragging');
        if (moved) {
          var s = stepSize();
          car.scrollTo({ left: Math.round(car.scrollLeft / s) * s, behavior: 'smooth' });
        }
      });
      car.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }
  });

  /* ------------------------------------------------------------ toast */
  var toastEl = $('[data-toast]');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2800);
  }

  /* ------------------------------------------------------------ cart */
  var SECTION = 'ukd-cart-drawer';

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', !n);
      el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
      var btn = el.closest('.cart-btn');
      if (btn) btn.setAttribute('aria-label', 'Basket, ' + n + ' items');
    });
    $$('.cart-drawer__count').forEach(function (el) { el.textContent = n; });
  }

  function renderSections(sections) {
    if (!sections || !sections[SECTION]) return;
    var tmp = doc.createElement('div');
    tmp.innerHTML = sections[SECTION];
    var body = $('[data-cart-body]', tmp);
    var foot = $('[data-cart-foot]', tmp);
    $$('[data-cart-body]').forEach(function (el) { if (body) el.innerHTML = body.innerHTML; });
    $$('[data-cart-foot]').forEach(function (el) { if (foot) el.innerHTML = foot.innerHTML; });
  }

  function refreshCart() {
    return fetch(routes.root.replace(/\/$/, '') + '/?sections=' + SECTION)
      .then(function (r) { return r.json(); })
      .then(renderSections)
      .then(function () { return fetch(routes.root.replace(/\/$/, '') + '/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) { setCount(cart.item_count); });
  }

  function addToCart(body) {
    body.append('sections', SECTION);
    body.append('sections_url', window.location.pathname);
    return fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) throw new Error(data.description || data.message || 'This item could not be added.');
          return data;
        });
      })
      .then(function (data) {
        renderSections(data.sections);
        return fetch(routes.root.replace(/\/$/, '') + '/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) { setCount(cart.item_count); return cart; });
  }
  window.UKD.addToCart = addToCart;

  doc.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-line-qty]');
    if (!qtyBtn) return;
    var line = qtyBtn.closest('[data-line]');
    if (!line) return;
    e.preventDefault();
    line.classList.add('is-removing');
    fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line.getAttribute('data-line'), 10), quantity: Math.max(0, parseInt(qtyBtn.getAttribute('data-line-qty'), 10)), sections: [SECTION], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status) throw new Error(cart.description || cart.message);
        renderSections(cart.sections);
        setCount(cart.item_count);
      })
      .catch(function (err) { line.classList.remove('is-removing'); toast(err.message || 'Could not update your basket.'); });
  });

  // Quick add on product cards
  doc.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-quick-toggle]');
    if (toggle) {
      var wrap = toggle.closest('[data-quick]');
      var isOpen = wrap.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      $$('[data-quick].is-open').forEach(function (w) { if (w !== wrap) { w.classList.remove('is-open'); $('[data-quick-toggle]', w).setAttribute('aria-expanded', 'false'); } });
      return;
    }
    var add = e.target.closest('[data-add]');
    if (!add || add.disabled) return;
    add.classList.add('is-loading');
    var fd = new FormData();
    fd.append('id', add.getAttribute('data-add'));
    fd.append('quantity', '1');
    addToCart(fd)
      .then(function () {
        var w = add.closest('[data-quick]');
        if (w) { w.classList.remove('is-open'); $('[data-quick-toggle]', w).setAttribute('aria-expanded', 'false'); }
        open('cart');
      })
      .catch(function (err) { toast(err.message); })
      .then(function () { add.classList.remove('is-loading'); });
  });
  doc.addEventListener('click', function (e) {
    if (e.target.closest('[data-quick]')) return;
    $$('[data-quick].is-open').forEach(function (w) { w.classList.remove('is-open'); });
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart().catch(function () {}); });

  /* ------------------------------------------------------------ accordions */
  $$('[data-acc]').forEach(function (d) {
    var summary = $('summary', d);
    var body = $('.acc__body', d);
    if (!summary || !body || reduceMotion || !body.animate) return;
    var anim = null;
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (anim) anim.cancel();
      if (d.open) {
        var h = body.offsetHeight;
        anim = body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 380, easing: 'cubic-bezier(.22,1,.36,1)' });
        anim.onfinish = function () { d.open = false; anim = null; };
      } else {
        d.open = true;
        var target = body.offsetHeight;
        anim = body.animate([{ height: '0px', opacity: 0 }, { height: target + 'px', opacity: 1 }], { duration: 480, easing: 'cubic-bezier(.22,1,.36,1)' });
        anim.onfinish = function () { anim = null; };
      }
    });
  });

  /* ------------------------------------------------------------ sort */
  $$('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ------------------------------------------------------------ size units */
  function toInches(range) {
    return range.split('–').map(function (v) { return (Math.round((parseFloat(v) / 2.54) * 2) / 2).toString(); }).join('–');
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-unit]');
    if (!b) return;
    var unit = b.getAttribute('data-unit');
    $$('[data-unit]').forEach(function (x) { var on = x.getAttribute('data-unit') === unit; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    $$('[data-cm]').forEach(function (td) { var cm = td.getAttribute('data-cm'); td.textContent = unit === 'in' ? toInches(cm) : cm; });
  });

  /* ------------------------------------------------------------ table of contents (policy pages) */
  (function toc() {
    var body = $('[data-doc-body]');
    var aside = $('[data-toc]');
    var list = $('[data-toc-list]');
    if (!body || !aside || !list) return;
    var heads = $$('h2', body);
    if (heads.length < 3) return;
    heads.forEach(function (h, i) {
      if (!h.id) h.id = 'section-' + (i + 1);
      var li = doc.createElement('li');
      var a = doc.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });
    aside.hidden = false;
    var links = $$('a', list);
    if (!('IntersectionObserver' in window)) return;
    var tio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('href') === '#' + en.target.id); });
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    heads.forEach(function (h) { tio.observe(h); });
  })();

  /* ------------------------------------------------------------ order tracking */
  $$('[data-track-form]').forEach(function (form) {
    var input = $('[data-track-input]', form);
    var msg = $('[data-track-msg]', form);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var value = (input.value || '').replace(/\s+/g, '').toUpperCase();
      var valid = /^[A-Z]{2}\d{9}GB$/.test(value) || /^[A-Z0-9]{10,24}$/.test(value);
      if (!valid) {
        msg.hidden = false;
        msg.textContent = 'Please check the tracking number. It is in your dispatch email and usually looks like AB123456789GB.';
        form.classList.remove('is-shake'); void form.offsetWidth; form.classList.add('is-shake');
        input.focus();
        return;
      }
      msg.hidden = true;
      window.open('https://www.royalmail.com/track-your-item#/tracking-results/' + encodeURIComponent(value), '_blank', 'noopener');
    });
  });

  /* ------------------------------------------------------------ product page */
  var BANK_HOLIDAYS = ['2026-01-01', '2026-04-03', '2026-04-06', '2026-05-04', '2026-05-25', '2026-08-31', '2026-12-25', '2026-12-28',
    '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28'];

  function londonParts(date) {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false, weekday: 'short' });
    var o = {};
    f.formatToParts(date).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24 };
  }
  function iso(dt) { return dt.toISOString().slice(0, 10); }
  function isWorking(dt) { var w = dt.getUTCDay(); return w !== 0 && w !== 6 && BANK_HOLIDAYS.indexOf(iso(dt)) === -1; }
  function addWorking(dt, n) { var d = new Date(dt); while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); if (isWorking(d)) n--; } return d; }
  function fmt(dt) { return dt.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }); }

  function initEta() {
    var box = $('[data-eta]');
    if (!box) return;
    var p = londonParts(new Date());
    var today = new Date(Date.UTC(p.y, p.m - 1, p.d));
    var dispatch = today;
    var sameDay = isWorking(today) && p.h < 17;
    if (!sameDay) dispatch = addWorking(today, 1);
    var d1 = $('[data-eta-dispatch]', box);
    var d2 = $('[data-eta-window]', box);
    if (d1) d1.textContent = sameDay
      ? 'Order before 5:00 pm today (UK time) and we dispatch it today.'
      : 'Order now and we dispatch it on ' + fmt(dispatch) + '.';
    if (d2) {
      var t48a = addWorking(dispatch, 2), t48b = addWorking(dispatch, 3);
      d2.textContent = 'Estimated delivery: ' + fmt(t48a) + ' to ' + fmt(t48b) + ' by Royal Mail Tracked 48.';
    }
  }

  $$('[data-product]').forEach(function (scope) {
    initEta();
    var jsonEl = $('[data-product-json]', scope);
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    var form = $('[data-product-form]', scope);
    var idInput = $('[data-variant-id]', scope);
    var atc = $('[data-atc]', scope);
    var atcLabel = $('[data-atc-label]', scope);
    var errorEl = $('[data-form-error]', scope);

    function selected() {
      var opts = [];
      $$('[data-option]:checked', scope).forEach(function (r) { opts[+r.getAttribute('data-option')] = r.value; });
      return opts;
    }
    function onChange() {
      var opts = selected();
      var v = data.variants.filter(function (x) { return x.options.every(function (o, i) { return opts[i] === undefined || o === opts[i]; }); })[0];
      $$('[data-option-label]', scope).forEach(function (l, i) { if (opts[i]) l.textContent = opts[i]; });
      if (!v) { atc.disabled = true; atcLabel.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? 'Add to basket' : 'Sold out';
      $$('[data-price]').forEach(function (p) { p.textContent = v.price; });
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    $$('[data-option]', scope).forEach(function (r) { r.addEventListener('change', onChange); });

    $$('[data-qty]', scope).forEach(function (q) {
      var input = $('input', q);
      $$('[data-qty-step]', q).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.min(10, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10)));
          input.value = v;
        });
      });
    });

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled) return;
      errorEl.hidden = true;
      atc.classList.add('is-loading');
      atc.disabled = true;
      addToCart(new FormData(form))
        .then(function () {
          atc.classList.add('is-added');
          setTimeout(function () { open('cart'); }, 520);
          setTimeout(function () { atc.classList.remove('is-added'); }, 2200);
        })
        .catch(function (err) { errorEl.hidden = false; errorEl.textContent = err.message; })
        .then(function () { atc.classList.remove('is-loading'); atc.disabled = false; });
    });

    // Gallery
    var gallery = $('[data-gallery]', scope);
    if (gallery) {
      var track = $('[data-gallery-track]', gallery);
      var slides = $$('.gallery__slide', track);
      var thumbs = $$('[data-gallery-thumb]', gallery);
      var counter = $('[data-gallery-current]', gallery);
      var current = 0;
      var go = function (i) {
        current = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[current].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      var sync = function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i === current && thumbs[i] && thumbs[i].classList.contains('is-active')) return;
        current = i;
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        if (counter) counter.textContent = i + 1;
        var t = thumbs[i];
        if (t) {
          var rail = t.closest('.gallery__thumbs');
          if (rail && rail.scrollWidth > rail.clientWidth) rail.scrollTo({ left: t.parentElement.offsetLeft - 20, behavior: 'smooth' });
        }
      };
      track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-gallery-thumb')); }); });
      var prevB = $('[data-gallery-prev]', gallery), nextB = $('[data-gallery-next]', gallery);
      if (prevB) prevB.addEventListener('click', function () { go(current - 1); });
      if (nextB) nextB.addEventListener('click', function () { go(current + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      });
      track.setAttribute('tabindex', '0');

      if (finePointer && window.matchMedia('(min-width: 990px)').matches) {
        $$('[data-zoom]', gallery).forEach(function (z) {
          z.addEventListener('pointerenter', function () { z.classList.add('is-zoom'); });
          z.addEventListener('pointerleave', function () { z.classList.remove('is-zoom'); });
          z.addEventListener('pointermove', function (e) {
            var r = z.getBoundingClientRect();
            z.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
            z.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
          });
        });
      }
    }

    // Sticky bar
    var sticky = $('[data-sticky-buy]', scope);
    if (sticky && atc && 'IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          var sb = $('[data-sticky-atc]', sticky);
          if (sb) sb.tabIndex = show ? 0 : -1;
        });
      });
      sio.observe(atc);
      var sb = $('[data-sticky-atc]', sticky);
      if (sb) sb.addEventListener('click', function () {
        var sizes = $('.sizes', scope) || form;
        scrollToEl(sizes, -120);
        setTimeout(function () { var c = $('[data-option]:checked', scope); if (c) c.focus({ preventScroll: true }); }, 600);
      });
    }
  });
})();
